import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';

import { ImportCsvSearchSchema } from '@/features/import-csv/zod-schemas';

import { getSoftware } from '../_$id/-query/api';

export const Route = createFileRoute('/_staff/software/$id/import-csv')({
  validateSearch: zodValidator(ImportCsvSearchSchema),
  loader: async ({ params }) => {
    return await getSoftware(params.id);
  },
});
